// Décrit un élément DOM (cible d'un clic, formulaire soumis) en une chaîne
// lisible pour le fil des gestes (fil.ts) — SANS JAMAIS révéler la valeur
// saisie dans un champ (ADR 0005, §6.13 : aucune valeur saisie dans un
// formulaire ne part avec un signalement). On ne lit donc jamais `.value` ni
// `getAttribute("value")` dans ce fichier.

const TEXTE_MAX = 60;

function estIgnore(el: Element): boolean {
  let node: Element | null = el;
  while (node) {
    if (node.getAttribute("data-fil") === "ignorer") return true;
    node = node.parentElement;
  }
  return false;
}

function texteVisible(el: Element): string {
  return (el.textContent ?? "").trim().replace(/\s+/g, " ");
}

// Priorité : aria-label > texte visible (tronqué à 60) > name/id > tagName.
// Pour un <input>/<select>/<textarea> sans enfants, `textContent` est
// naturellement vide : la valeur du champ n'entre donc jamais en jeu ici.
export function describeClickTarget(el: Element): string {
  if (estIgnore(el)) return "";

  const ariaLabel = el.getAttribute("aria-label")?.trim();
  if (ariaLabel) return ariaLabel;

  const texte = texteVisible(el);
  if (texte) return texte.length > TEXTE_MAX ? texte.slice(0, TEXTE_MAX) : texte;

  const identifiant = el.getAttribute("name") || el.getAttribute("id");
  if (identifiant) return identifiant;

  return el.tagName.toLowerCase();
}

export interface DescriptionSoumission {
  formulaire: string;
  champs: string[];
}

// Nom du formulaire (id > name > aria-label > "formulaire") et NOMS des
// champs soumis — jamais leurs valeurs.
export function describeSubmit(form: HTMLFormElement): DescriptionSoumission {
  const formulaire =
    form.id || form.getAttribute("name") || form.getAttribute("aria-label") || "formulaire";

  const champs: string[] = [];
  const vus = new Set<string>();
  for (const champ of Array.from(form.elements)) {
    const nom = champ.getAttribute("name") || champ.getAttribute("id");
    if (!nom || vus.has(nom)) continue;
    vus.add(nom);
    champs.push(nom);
  }

  return { formulaire, champs };
}
